import { z } from '@uturn/portal/zod';

/**
 * countryCode is required in ShipmentLocation => determine isGBRShipment, isCrossBorderShipment
 */
export const countryCodeSchema = z.string();
